import angular from 'angular';

import ErrorNotificationComponent from './error-notification.cmpt';

export default angular
    .module('application.component.notifications.component.error-notification', [])
    .component(ErrorNotificationComponent.selector, ErrorNotificationComponent);



// WEBPACK FOOTER //
// ./src/application/component/notifications/component/error-notification/index.js